(function($) {

/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map( $el ) {

	// var
	var $markers = $el.find('.marker');


	// vars
	var args = {
		zoom		: 16,
		center		: new google.maps.LatLng(0, 0),
		mapTypeId	: google.maps.MapTypeId.ROADMAP
	};


	// create map
	var map = new google.maps.Map( $el[0], args);


	// add a markers reference
	map.markers = [];

	// return
	return map;

}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker( marker_data, map ) {

	// var
	var latlng = new google.maps.LatLng( marker_data.lat, marker_data.lng );

	// create marker
	var marker = new google.maps.Marker({
		position	: latlng,
		map			: map,
	});

    var icon_url = marker_data.icon;

    if (icon_url !== undefined ) {
        marker.setIcon(acfmaps.imgdir + icon_url + "-small.png");
    }

	// add to array
	map.markers.push( marker );

	// if marker contains HTML, add it to an infoWindow
	if( marker_data.content )
	{
		// create info window
		var infowindow = new google.maps.InfoWindow({
			content		: marker_data.content,
            maxWidth    : 325
		});

		// show info window when marker is clicked
		google.maps.event.addListener(marker, 'click', function() {

			infowindow.open( map, marker );

		});

        google.maps.event.addListener(infowindow, 'domready', function() {

            // Reference to the DIV which receives the contents of the infowindow using jQuery
            var iwOuter = $('.gm-style-iw');

            /* The DIV we want to change is above the .gm-style-iw DIV.
                * So, we use jQuery and create a iwBackground variable,
                * and took advantage of the existing reference to .gm-style-iw for the previous DIV with .prev().
                */
            var iwBackground = iwOuter.prev();

            // Remove the background shadow DIV
            iwBackground.children(':nth-child(2)').css({'display' : 'none'});

            // Remove the white background DIV
            iwBackground.children(':nth-child(4)').css({'display' : 'none'});

            var iwCloseBtn = iwOuter.next();

            iwCloseBtn.addClass("gm-style-close");

            var iwContainer = iwOuter.parent();
            iwContainer.addClass("gm-style-iw-container");

            // The API automatically applies 0.7 opacity to the button after the mouseout event.
            // This function reverses this event to the desired value.
            iwCloseBtn.mouseout(function(){
                $(this).css({opacity: '1'});
            });

        });
	}

}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map( map ) {

	// vars
	var bounds = new google.maps.LatLngBounds();

	// loop through all markers and create bounds
	$.each( map.markers, function( i, marker ){

		var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

		bounds.extend( latlng );

	});

    // set center of map
    map.setCenter( bounds.getCenter() );
    map.setZoom( 10 );

}


/*
*  document ready
*
*  This function will render each map when the document is ready (page has loaded)
*
*  @type	function
*  @date	8/11/2013
*  @since	5.0.0
*
*  @param	n/a
*  @return	n/a
*/
// global var
var map = null;
var circleRadius = 40000;
var cityCircle = null;
var mapCenter = null;

function delete_markers(map) {
    for (var i = 0; i < map.markers.length; i++) {
        map.markers[i].setMap(null);
    }
    map.markers = [];
}

function update_markers() {
    if (mapCenter === null) {
        return;
    }

    var ajax_data = {
        action: "place_markers",
        lat: mapCenter.lat,
        lng: mapCenter.lng,
        radius: circleRadius,
    };

    $.ajax({
        type: "POST",
        dataType: "json",
        url: acfmaps.ajaxurl,
        data: ajax_data,
        success: function(data){
            delete_markers(map);

            for (var i = 0; i < data.length; i++) {
                add_marker(data[i], map);
            }

            center_map(map);
        }

    });
}

$(document).ready(function(){

	$('.acf-map').each(function(){

		// create map
		map = new_map( $(this) );
        var lat = $(this).data("lat");
        var lng = $(this).data("lng");

        if (lat && lng) {
            mapCenter = {
                "lat": $(this).data("lat"),
                "lng": $(this).data("lng")
            }
        }

	});

    $('.tabs').on('change.zf.tabs', function(e, tgt) {
        var $target_tab = tgt.find("a");

        if ($target_tab.length) {
            var sel = $target_tab.attr("href");

            if (sel == "#okolica") {
                google.maps.event.trigger(map, "resize");
                update_markers();
            }
        }
    });

    $(window).resize(function() {
        google.maps.event.trigger(map, "resize");
    });

});

})(jQuery);
